(() => {
  if (customElements.get('nr-sim-offer')) return;
  customElements.define('nr-sim-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.choice = this.querySelector('[data-sim-choice]');
      this.button = this.querySelector('[data-sim-add]');
      this.status = this.querySelector('[data-sim-status]');
      this.labels = JSON.parse(this.querySelector('[data-sim-labels]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-sim-variants]')?.textContent || '[]');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.choice.addEventListener('change', () => this.update(), options);
      this.button.addEventListener('click', () => this.add(), options);
      window.addEventListener('pageshow', () => {
        this.busy = false;
        this.choice.disabled = false;
        this.update();
      }, options);
      this.onVariant = () => this.update();
      this.form = document.getElementById(this.dataset.formId);
      this.form?.addEventListener('variant:changed', this.onVariant, options);
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.initialized = false;
    }
    base() {
      const id = this.form ? new FormData(this.form).get('id') : this.dataset.baseId;
      return this.variants.find(variant => String(variant.id) === String(id));
    }
    money(value) { return this.formatter.format(value / 100); }
    update() {
      const option = this.choice.selectedOptions[0];
      const selected = !!option?.value && !option.disabled;
      this.querySelector('[data-sim-summary]').hidden = !selected;
      if (!selected) return;
      const price = Number(option.dataset.price);
      const base = this.base();
      this.querySelector('[data-sim-choice-title]').textContent = option.dataset.title;
      this.querySelector('[data-sim-choice-price]').textContent = this.money(price);
      this.querySelector('[data-sim-details]').href = option.dataset.url;
      if (this.dataset.pair === 'true') {
        this.querySelector('[data-sim-base-price]').textContent = this.money(base?.price || 0);
        this.querySelector('[data-sim-total]').textContent = this.money(price + (base?.price || 0));
      }
      const saving = this.querySelector('[data-sim-bay-saving]');
      const baySaving = Number(option.dataset.compare) - price;
      saving.hidden = this.dataset.direction !== 'bays' || baySaving <= 0;
      saving.textContent = baySaving > 0 ? this.labels.bay_saved.replace('__AMOUNT__', this.money(baySaving)) : '';
      this.button.disabled = this.busy || (this.dataset.pair === 'true' && !base?.available);
      if (!this.busy) this.button.textContent = this.dataset.pair === 'true' ? (base?.available ? this.labels.add_pair : this.labels.unavailable) : this.labels.add_single;
    }
    async add() {
      if (this.busy) return;
      const option = this.choice.selectedOptions[0];
      const base = this.base();
      if (!option?.value || option.disabled || (this.dataset.pair === 'true' && !base?.available)) return;
      const items = [{ id: Number(option.value), quantity: 1 }];
      if (this.dataset.pair === 'true') items.unshift({ id: base.id, quantity: 1 });
      this.busy = true;
      this.button.disabled = true;
      this.choice.disabled = true;
      this.button.textContent = this.labels.adding;
      this.status.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.labels.failure);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = `${error.message} ${this.labels.retry}`;
        this.status.hidden = false;
        this.busy = false;
        this.choice.disabled = false;
        this.update();
      }
    }
  });
})();
